﻿$.fn.dxCtrlJaugeIa = function custom_dxCtrlJaugeIa(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrljaugeia dx-ctrl");
        this.createInstance(new cdxCtrlJaugeIa(this, option));
    }
    return this;
}

window.ThemeJaugeIaLoaded = false
window.cdxCtrlJaugeIa = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();
        if (!ThemeJaugeIaLoaded) {
            $('<style>.spinneria div { background: ' + theme.backgroundcolorAccent + '; }</style>').appendTo('head');
            ThemeJaugeIaLoaded = true
        }
        container.html("<div></div><div></div><div></div><div></div><div></div>")
        container.addClass("spinneria")
    }


    this.element = function () { return container }

    mConstruit();
}